import { ICreateChangeBase } from '../../../shared/models/models';

export enum ADGroupMappingGroupCategory {
    Group = 0,
    OrganizationUnit = 1,
}

export interface IADGroupMapping extends ICreateChangeBase {
    GroupId: string;
    GroupName: string;
    Mappings: IADGroupMappingItem[];
    GroupCategory: ADGroupMappingGroupCategory;
    GroupGuid: string;
    GroupParentGuids: string[];
    ObjectId: number;
    ObjectType;
    ObjectName: string;
}

export interface IADGroupMappingItem extends ICreateChangeBase {
    Id: number;
    ObjectId: number;
    ObjectType;
    ObjectName: string;
}

export interface IADGroupMappingListModel extends IADGroupMapping, IADGroupMappingItem {
    ChildGroups: IADGroupMappingListModel[];
    IsContainer: boolean;
    ParentGroups: IADGroupMappingListModel[];
}

export interface IADDisplayDataItem {
    group: IADGroupMappingListModel;
    ChildGroups: IADDisplayDataItem[];
}
